'use client';

import {
  BREED_HANDBOOKS_ADMIN_ONLY_FLAG,
  BREED_HANDBOOKS_FLAG
} from '@paction-2.0/util/constants/breedHandbooks';

import { useFeatureFlags } from '@/hooks/useFeatureFlags';
import { useAuth } from '@/lib/auth/AuthProvider';
import { isAdmin } from '@/lib/auth/roles';

export function useBreedHandbooksEnabled(): {
  isEnabled: boolean;
  isLoading: boolean;
} {
  const { isEnabled: flagEnabled, isLoading } = useFeatureFlags();
  const { session } = useAuth();

  if (!flagEnabled(BREED_HANDBOOKS_FLAG)) {
    return { isEnabled: false, isLoading };
  }

  if (flagEnabled(BREED_HANDBOOKS_ADMIN_ONLY_FLAG) && !isAdmin(session)) {
    return { isEnabled: false, isLoading };
  }

  return { isEnabled: true, isLoading };
}
